export default "__VITE_ASSET__D3u6NQcn__"